import script from "./CategoryMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./CategoryMultiSelect.vue?vue&type=style&index=0&id=8e2b9974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e2b9974"]])

export default __exports__